import { inject, Injectable } from '@angular/core';
import { SysUtilService } from '../sysUtil.service';
import * as ExcelJS from 'exceljs';
import { env } from '../../../../app.constant';

@Injectable({
  providedIn: 'root'
})
export class SabaudbStfSumService {

  private sysUtil: SysUtilService = inject(SysUtilService);

  private initialPosition = 12;

  // private numberFormat = "#,##0.00";
  private numberFormat = "#,##0.00_);[Red](#,##0.00)";

  private fontStyle = {
    header: { name: 'Times New Roman', size: 10, bold: true },
    content: { name: 'Times New Roman', size: 10 }
  };

  private columns = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
    'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
    'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD',
    'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL'
  ];

  private columnTitle = [
    'PRE', 'SB', 'STF',
    'PRE', 'SB', 'STF',
    'PRE', 'SB', 'STF',
    'PRE', 'SB', 'STF',
    'PRE', 'SB', 'STF',
    'PRE', 'SB', 'STF',
    '', '', '',
    '', '', '',
    'PRE', 'SB', 'STF',
    'Due & Demandable', 'Due & Demandable', 'Due & Demandable',
    'Due & Demandable', 'Due & Demandable', 'Due & Demandable',
    'Unreleased Approved Budget', 'Unreleased Approved Budget', 'Unreleased Approved Budget'
  ];

  private borderStyle: any = {
    thin: { style: 'thin' },
    full: {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    },
    topBottom: {
      top: { style: 'thin' },
      bottom: { style: 'thin' }
    },
    leftRight: {
      left: { style: 'thin' },
      right: { style: 'thin' }
    },
    topLeft: {
      top: { style: 'thin' },
      left: { style: 'thin' }
    },
    topRight: {
      top: { style: 'thin' },
      left: { style: 'thin' }
    },
    bottomLeft: {
      bottom: { style: 'thin' },
      left: { style: 'thin' }
    },
    bottomRight: {
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
  };

  private formula: any = {
    e: `IF(OR(NOT(C*=""),NOT(D*="")),IF(C*="",0,C*)+IF(D*="",0,D*),"")`,
    h: `IF(OR(NOT(F*=""),NOT(G*="")),IF(F*="",0,F*)+IF(G*="",0,G*),"")`,
    i: `IF(OR(NOT(C*=""),NOT(F*="")),IF(C*="",0,C*)+IF(F*="",0,F*),"")`,
    j: `IF(OR(NOT(D*=""),NOT(G*="")),IF(D*="",0,D*)+IF(G*="",0,G*),"")`,
    k: `IF(OR(NOT(I*=""),NOT(J*="")),IF(I*="",0,I*)+IF(J*="",0,J*),"")`,
    n: `IF(OR(NOT(L*=""),NOT(M*="")),IF(L*="",0,L*)+IF(M*="",0,M*),"")`,
    q: `IF(OR(NOT(O*=""),NOT(P*="")),IF(O*="",0,O*)+IF(P*="",0,P*),"")`,
    r: `IF(OR(NOT(L*=""),NOT(O*="")),IF(L*="",0,L*)+IF(O*="",0,O*),"")`,
    s: `IF(OR(NOT(M*=""),NOT(P*="")),IF(M*="",0,M*)+IF(P*="",0,P*),"")`,
    t: `IF(OR(NOT(R*=""),NOT(S*="")),IF(R*="",0,R*)+IF(S*="",0,S*),"")`,
    w: `IF(OR(NOT(U*=""),NOT(V*="")),IF(U*="",0,U*)+IF(V*="",0,V*),"")`,
    z: `IF(OR(NOT(X*=""),NOT(Y*="")),IF(X*="",0,X*)+IF(Y*="",0,Y*),"")`,
    aa: `IF(OR(NOT(R*=""),NOT(U*="")),IF(R*="",0,R*)-IF(U*="",0,U*),"")`,
    ab: `IF(OR(NOT(S*=""),NOT(V*="")),IF(S*="",0,S*)-IF(V*="",0,V*),"")`,
    ac: `IF(OR(NOT(AA*=""),NOT(AB*="")),IF(AA*="",0,AA*)+IF(AB*="",0,AB*),"")`,
    af: `IF(OR(NOT(AD*=""),NOT(AE*="")),IF(AD*="",0,AD*)+IF(AE*="",0,AE*),"")`,
    ag: `IF(OR(NOT(U*=""),NOT(X*=""),NOT(AD*="")),IF(U*="",0,U*)-IF(X*="",0,X*)-IF(AD*="",0,AD*),"")`,
    ah: `IF(OR(NOT(T*=""),NOT(Y*=""),NOT(AE*="")),IF(T*="",0,T*)-IF(Y*="",0,Y*)-IF(AE*="",0,AE*),"")`,
    ai: `IF(OR(NOT(AG*=""),NOT(AH*="")),IF(AG*="",0,AG*)+IF(AH*="",0,AH*),"")`,
    aj: `IF(OR(NOT(I*=""),NOT(L*="")),IF(I*="",0,I*)-IF(L*="",0,L*),"")`,
    ak: `IF(OR(NOT(J*=""),NOT(M*="")),IF(J*="",0,J*)-IF(M*="",0,M*),"")`,
    al: `IF(OR(NOT(AD*=""),NOT(AE*="")),IF(AD*="",0,AD*)+IF(AE*="",0,AE*),"")`
  };

  private allotmentClass = [
    "Personnel Services",
    "Maintenance and Other Operating Expenses",
    "Financial Expenses",
    "Non-Cash Expenses",
    "Capital Outlays (Budgetary Accounts)",
    "Research Projects",
    "Extension, PAPs",
    "Mandatory Reserve Fund",
    "Reserve Fund",
  ];

  private setHeader(ws: ExcelJS.Worksheet, campus: number, year: number) {
    let position = this.initialPosition + 1;

    // header title
    ws.mergeCells(`A1:AA1`);
    let row1 = ws.getCell(`A1`);
    row1.value = "Republic of the Philippines";
    row1.font = this.fontStyle.content;
    row1.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A2:AA2`);
    let row2 = ws.getCell(`A2`);
    row2.value = "BATANGAS STATE UNIVERSITY";
    row2.font = this.fontStyle.header;
    row2.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A3:AA3`);
    let row3 = ws.getCell(`A3`);
    row3.value = "The National Engineering University";
    row3.font = this.fontStyle.header;
    row3.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    let campusData = env.campuses.find((c: any) => c.value == campus);
    ws.mergeCells(`A4:AA4`);
    let row4 = ws.getCell(`A4`);
    row4.value = `${campusData.details.name}`;
    row4.font = this.fontStyle.header;
    row4.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A5:AA5`);
    let row5 = ws.getCell(`A5`);
    row5.value = `${campusData.details.addr}`;
    row5.font = this.fontStyle.content;
    row5.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A6:AA6`);
    let row6 = ws.getCell(`A6`);
    row6.value = `Tel Nos.: ${campusData.details.contact}`;
    row6.font = this.fontStyle.content;
    row6.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A7:AA7`);
    let row7 = ws.getCell(`A7`);
    row7.value = `E-mail Address: ${campusData.details.email} | Website Address: https://batstate-u.edu.ph`;
    row7.font = this.fontStyle.content;
    row7.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A9:AA9`);
    let row9 = ws.getCell(`A9`);
    row9.value = "Summary of Approved Budget, Allotment, Utilizations & Balances (SABAUD)";
    row9.font = this.fontStyle.header;
    row9.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A10:AA10`);
    let row10 = ws.getCell(`A10`);
    row10.value = `Special Trust Fund (STF) FY ${year}`;
    row10.font = this.fontStyle.header;
    row10.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`A11:AA11`);
    let row11 = ws.getCell(`A11`);
    row11.value = `as of ${year}`;
    row11.font = this.fontStyle.header;
    row11.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    // header body
    let ctRow = ws.getRow(position + 1);
    ctRow.height = 56;

    ws.mergeCells(`A${position}:A${position + 3}`);
    let particulars = ws.getCell(`A${position + 3}`);
    particulars.value = "Particulars";
    particulars.font = this.fontStyle.header;
    particulars.border = this.borderStyle.full;
    particulars.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`B${position}:B${position + 3}`);
    let uacs_code = ws.getCell(`B${position + 3}`);
    uacs_code.value = "UACS Code";
    uacs_code.font = this.fontStyle.header;
    uacs_code.border = this.borderStyle.full;
    uacs_code.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`C${position}:K${position}`);
    let approved_budget = ws.getCell(`C${position}`);
    approved_budget.value = `Approved Budget FY ${year}`;
    approved_budget.font = this.fontStyle.header;
    approved_budget.border = this.borderStyle.full;
    approved_budget.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`L${position}:T${position}`);
    let allotment = ws.getCell(`L${position}`);
    allotment.value = "Allotment";
    allotment.font = this.fontStyle.header;
    allotment.border = this.borderStyle.full;
    allotment.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`U${position}:W${position}`);
    let utilizations = ws.getCell(`U${position}`);
    utilizations.value = "Utilization";
    utilizations.font = this.fontStyle.header;
    utilizations.border = this.borderStyle.full;
    utilizations.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`X${position}:Z${position}`);
    let disbursement = ws.getCell(`X${position}`);
    disbursement.value = "Disbursement";
    disbursement.font = this.fontStyle.header;
    disbursement.border = this.borderStyle.full;
    disbursement.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`AA${position}:AL${position}`);
    let balances = ws.getCell(`AA${position}`);
    balances.value = "Balances";
    balances.font = this.fontStyle.header;
    balances.border = this.borderStyle.full;
    balances.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`C${position + 1}:E${position + 2}`);
    let approved_budget_section = ws.getCell(`C${position + 1}`);
    approved_budget_section.value = `Approved Budget FY ${year}`;
    approved_budget_section.font = this.fontStyle.header;
    approved_budget_section.border = this.borderStyle.full;
    approved_budget_section.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`F${position + 1}:H${position + 2}`);
    let adjustments = ws.getCell(`F${position + 1}`);
    adjustments.value = "Adjustment";
    adjustments.font = this.fontStyle.header;
    adjustments.border = this.borderStyle.full;
    adjustments.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`I${position + 1}:K${position + 2}`);
    let adjusted_approved = ws.getCell(`I${position + 1}`);
    adjusted_approved.value = "Adjusted Approved Budget";
    adjusted_approved.font = this.fontStyle.header;
    adjusted_approved.border = this.borderStyle.full;
    adjusted_approved.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`L${position + 1}:N${position + 2}`);
    let allotment_received = ws.getCell(`L${position + 1}`);
    allotment_received.value = "Allotment Received";
    allotment_received.font = this.fontStyle.header;
    allotment_received.border = this.borderStyle.full;
    allotment_received.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`O${position + 1}:Q${position + 2}`);
    let allotment_adjustments = ws.getCell(`O${position + 1}`);
    allotment_adjustments.value = "Adjustments (Reduction, Modification)";
    allotment_adjustments.font = this.fontStyle.header;
    allotment_adjustments.border = this.borderStyle.full;
    allotment_adjustments.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`R${position + 1}:T${position + 2}`);
    let adjusted_total = ws.getCell(`R${position + 1}`);
    adjusted_total.value = "Adjusted Total Allotment";
    adjusted_total.font = this.fontStyle.header;
    adjusted_total.border = this.borderStyle.full;
    adjusted_total.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`U${position + 1}:U${position + 3}`);
    let util_pre = ws.getCell(`U${position + 1}`);
    util_pre.value = "PRE";
    util_pre.font = this.fontStyle.header;
    util_pre.border = this.borderStyle.full;
    util_pre.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`V${position + 1}:V${position + 3}`);
    let util_sb = ws.getCell(`V${position + 1}`);
    util_sb.value = "SB";
    util_sb.font = this.fontStyle.header;
    util_sb.border = this.borderStyle.full;
    util_sb.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`W${position + 1}:W${position + 3}`);
    let util_stf = ws.getCell(`W${position + 1}`);
    util_stf.value = "STF";
    util_stf.font = this.fontStyle.header;
    util_stf.border = this.borderStyle.full;
    util_stf.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`X${position + 1}:X${position + 3}`);
    let disb_pre = ws.getCell(`X${position + 1}`);
    disb_pre.value = "PRE";
    disb_pre.font = this.fontStyle.header;
    disb_pre.border = this.borderStyle.full;
    disb_pre.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`Y${position + 1}:Y${position + 3}`);
    let disb_sb = ws.getCell(`Y${position + 1}`);
    disb_sb.value = "SB";
    disb_sb.font = this.fontStyle.header;
    disb_sb.border = this.borderStyle.full;
    disb_sb.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`Z${position + 1}:Z${position + 3}`);
    let disb_stf = ws.getCell(`Z${position + 1}`);
    disb_stf.value = "STF";
    disb_stf.font = this.fontStyle.header;
    disb_stf.border = this.borderStyle.full;
    disb_stf.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`AA${position + 1}:AC${position + 2}`);
    let unobligated = ws.getCell(`AA${position + 1}`);
    unobligated.value = "Unobligated Allotment";
    unobligated.font = this.fontStyle.header;
    unobligated.border = this.borderStyle.full;
    unobligated.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`AD${position + 1}:AL${position + 1}`);
    let unpaid = ws.getCell(`AD${position + 1}`);
    unpaid.value = "Unpaid";
    unpaid.font = this.fontStyle.header;
    unpaid.border = this.borderStyle.full;
    unpaid.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`AD${position + 2}:AF${position + 2}`);
    let due_demandable1 = ws.getCell(`AD${position + 2}`);
    due_demandable1.value = "Due & Demandable";
    due_demandable1.font = this.fontStyle.header;
    due_demandable1.border = this.borderStyle.full;
    due_demandable1.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`AG${position + 2}:AI${position + 2}`);
    let due_demandable2 = ws.getCell(`AG${position + 2}`);
    due_demandable2.value = "Due & Demandable";
    due_demandable2.font = this.fontStyle.header;
    due_demandable2.border = this.borderStyle.full;
    due_demandable2.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    ws.mergeCells(`AJ${position + 2}:AL${position + 2}`);
    let unreleased = ws.getCell(`AJ${position + 2}`);
    unreleased.value = "Unreleased Approved Budget";
    unreleased.font = this.fontStyle.header;
    unreleased.border = this.borderStyle.full;
    unreleased.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

    let colExceptions = ['U', 'V', 'W', 'X', 'Y', 'Z'];
    this.columns.filter((l: string) => l != 'A' && l != 'B').forEach((t: string, i: number) => {
      if (colExceptions.includes(t)) {
        return;
      }

      let ct = ws.getCell(`${t}${position + 3}`);
      ct.value = this.columnTitle[i];
      ct.font = this.fontStyle.header;
      ct.border = this.borderStyle.full;
      ct.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
    });


    // numbers in cell
    const cellNumberFormula = {
      5: "5=3+4",
      8: "8=6+7",
      9: "9=3+6",
      10: "10=4+7",
      11: "11=9+10",
      14: "14=12+13",
      17: "17=15+16",
      18: "18=12+15",
      19: "19=13+16",
      20: "20=18+19",
      23: "23=21+22",
      26: "26=24+25",
      27: "27=18-21",
      28: "28=19-22",
      29: "29=27+28",
      32: "32=30+31",
      33: "33=21-24-303",
      34: "34=20-25-31",
      35: "35=33+34",
      36: "36=9-12",
      37: "37=10-13",
      38: "38=30+31"
    };
    this.columns.forEach((l: string, i: number) => {
      let numCell = ws.getCell(`${l}${position + 4}`);
      let n = i + 1;
      numCell.value = (Object.keys(cellNumberFormula).includes(n.toString())) ? cellNumberFormula[n] : `${n}`;
      numCell.font = this.fontStyle.header;
      numCell.border = this.borderStyle.full;
      numCell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
    });
  }

  public createWorkSheet(wb: ExcelJS.Workbook, data: Array<any>, campus: number, year: number, sn: string, result: string) {
    let processedData = data.map((d: any) => {
      let dt = JSON.parse(JSON.stringify(d));
      dt.fnd_name = d.fnd_name.replaceAll(/(<([^>]+)>)|(\&nbsp;)/ig, '');


      dt.appr_amount = Number(dt.appr_amount_pre || 0) + Number(dt.appr_amount_sb || 0) + Number(dt.appr_amount_cb || 0);
      dt.adjustment_amount = Number(dt.adjustment_amount_pre || 0) + Number(dt.adjustment_amount_sb || 0) + Number(dt.adjustment_amount_cb || 0);
      dt.adjusted_amount = Number(dt.adjusted_amount_pre || 0) + Number(dt.adjusted_amount_sb || 0) + Number(dt.adjusted_amount_cb || 0);
      dt.total_allotment = Number(dt.total_allotment_pre || 0) + Number(dt.total_allotment_sb || 0) + Number(dt.total_allotment_cb || 0);
      dt.re_total = Number(dt.re_total_pre || 0) + Number(dt.re_total_sb || 0) + Number(dt.re_total_cb || 0);
      dt.total_adj = Number(dt.total_adj_pre || 0) + Number(dt.total_adj_sb || 0) + Number(dt.total_adj_cb || 0);
      dt.ors_total = Number(dt.ors_total_pre || 0) + Number(dt.ors_total_sb || 0) + Number(dt.ors_total_cb || 0);
      dt.due_demandable = Number(dt.due_demandable_pre || 0) + Number(dt.due_demandable_sb || 0) + Number(dt.due_demandable_cb || 0);
      dt.ors_unobligated_allotment = Number(dt.ors_unobligated_allotment_pre || 0) + Number(dt.ors_unobligated_allotment_sb || 0) + Number(dt.ors_unobligated_allotment_cb || 0);
      dt.unreleased_appr_amount = Number(dt.unreleased_appr_amount_pre || 0) + Number(dt.unreleased_appr_amount_sb || 0) + Number(dt.unreleased_appr_amount_cb || 0);
      dt.q1 = Number(dt.q1_pre || 0) + Number(dt.q1_sb || 0) + Number(dt.q1_cb || 0);
      dt.q2 = Number(dt.q2_pre || 0) + Number(dt.q2_sb || 0) + Number(dt.q2_cb || 0);
      dt.q3 = Number(dt.q3_pre || 0) + Number(dt.q3_sb || 0) + Number(dt.q3_cb || 0);
      dt.q4 = Number(dt.q4_pre || 0) + Number(dt.q4_sb || 0) + Number(dt.q4_cb || 0);
      dt.re_q1 = Number(dt.re_q1_pre || 0) + Number(dt.re_q1_sb || 0) + Number(dt.re_q1_cb || 0);
      dt.re_q2 = Number(dt.re_q2_pre || 0) + Number(dt.re_q2_sb || 0) + Number(dt.re_q2_cb || 0);
      dt.re_q3 = Number(dt.re_q3_pre || 0) + Number(dt.re_q3_sb || 0) + Number(dt.re_q3_cb || 0);
      dt.re_q4 = Number(dt.re_q4_pre || 0) + Number(dt.re_q4_sb || 0) + Number(dt.re_q4_cb || 0);
      dt.adj_q1 = Number(dt.adj_q1_pre || 0) + Number(dt.adj_q1_sb || 0) + Number(dt.adj_q1_cb || 0);
      dt.adj_q2 = Number(dt.adj_q2_pre || 0) + Number(dt.adj_q2_sb || 0) + Number(dt.adj_q2_cb || 0);
      dt.adj_q3 = Number(dt.adj_q3_pre || 0) + Number(dt.adj_q3_sb || 0) + Number(dt.adj_q3_cb || 0);
      dt.adj_q4 = Number(dt.adj_q4_pre || 0) + Number(dt.adj_q4_sb || 0) + Number(dt.adj_q4_cb || 0);
      dt.ors_q1 = Number(dt.ors_q1_pre || 0) + Number(dt.ors_q1_sb || 0) + Number(dt.ors_q1_cb || 0);
      dt.ors_q2 = Number(dt.ors_q2_pre || 0) + Number(dt.ors_q2_sb || 0) + Number(dt.ors_q2_cb || 0);
      dt.ors_q3 = Number(dt.ors_q3_pre || 0) + Number(dt.ors_q3_sb || 0) + Number(dt.ors_q3_cb || 0);
      dt.ors_q4 = Number(dt.ors_q4_pre || 0) + Number(dt.ors_q4_sb || 0) + Number(dt.ors_q4_cb || 0);
      dt.dis_q1 = Number(dt.dis_q1_pre || 0) + Number(dt.dis_q1_sb || 0) + Number(dt.dis_q1_cb || 0);
      dt.dis_q2 = Number(dt.dis_q2_pre || 0) + Number(dt.dis_q2_sb || 0) + Number(dt.dis_q2_cb || 0);
      dt.dis_q3 = Number(dt.dis_q3_pre || 0) + Number(dt.dis_q3_sb || 0) + Number(dt.dis_q3_cb || 0);
      dt.dis_q4 = Number(dt.dis_q4_pre || 0) + Number(dt.dis_q4_sb || 0) + Number(dt.dis_q4_cb || 0);
      dt.dis_total = Number(dt.dis_total_pre || 0) + Number(dt.dis_total_sb || 0) + Number(dt.dis_total_cb || 0);

      const exempted = ['fnd_name', 'acct_uacs_code', 'due_demandable', 'not_yet_due'];
      Object.keys(dt).forEach((key: string) => {
        if (!exempted.includes(key)) {
          dt[key] = (Number(dt[key]) == 0) ? "" : Number(dt[key]);
        }
      });
      return dt;
    });

    const ws = wb.addWorksheet(sn);

    let imageId = wb.addImage({ base64: result, extension: 'png' });
    ws.addImage(imageId, { tl: { col: 7, row: 0 }, ext: { width: 120, height: 110 } });

    ws.columns = [
      { header: "", key: "fnd_name", width: 46 },
      { header: "", key: "acct_uacs_code", width: 15 },
      { header: "", key: "appr_amount_pre", width: 16 },
      { header: "", key: "adjustment_amount", width: 16 },
      { header: "", key: "adjusted_amount", width: 16 },
      { header: "", key: "adjustment_amount_pre", width: 16 },
      { header: "", key: "q2", width: 16 },
      { header: "", key: "q3", width: 16 },
      { header: "", key: "adjusted_amount_pre", width: 16 },
      { header: "", key: "total_allotment", width: 16 },
      { header: "", key: "re_q1", width: 16 },
      { header: "", key: "total_allotment_pre", width: 16 },
      { header: "", key: "re_q3", width: 16 },
      { header: "", key: "re_q4", width: 16 },
      { header: "", key: "re_total_pre", width: 16 },
      { header: "", key: "adj_q1", width: 16 },
      { header: "", key: "adj_q2", width: 16 },
      { header: "", key: "total_adj_pre", width: 16 },
      { header: "", key: "adj_q4", width: 16 },
      { header: "", key: "total_adj", width: 16 },
      { header: "", key: "ors_total_pre", width: 16 },
      { header: "", key: "ors_q2", width: 16 },
      { header: "", key: "ors_q3", width: 16 },
      { header: "", key: "due_demandable", width: 16 },
      { header: "", key: "ors_total", width: 16 },
      { header: "", key: "dis_q1", width: 16 },
      { header: "", key: "ors_unobligated_allotment_pre", width: 16 },
      { header: "", key: "dis_q3", width: 16 },
      { header: "", key: "dis_q4", width: 16 },
      { header: "", key: "due_demandable_pre", width: 16 },
      { header: "", key: "ors_unobligated_allotment", width: 16 },
      { header: "", key: "due_demandable", width: 16 },
      { header: "", key: "due_demandable_pre", width: 16 },
      { header: "", key: "unreleased_appr_amount", width: 16 },
      { header: "", key: "unreleased_appr_amount", width: 16 },
      { header: "", key: "unreleased_appr_amount_pre", width: 16 },
      { header: "", key: "unreleased_appr_amount", width: 16 },
      { header: "", key: "unreleased_appr_amount", width: 16 },
    ];

    // console.log(`total_content`, data);

    this.setHeader(ws, Number(campus), Number(year));
    let position = this.initialPosition + 6;

    processedData.forEach((data: any, i: number) => {

      data.due_demandable = (Number(data.due_demandable) == 0) ? "" : Number(data.due_demandable);
      data.not_yet_due = (Number(data.not_yet_due) == 0) ? "" : Number(data.not_yet_due);

      const exempted = ['fnd_name', 'acct_uacs_code', 'due_demandable', 'not_yet_due'];
      Object.keys(data).forEach((key: string) => {
        if (!exempted.includes(key)) {
          data[key] = (Number(data[key]) == 0) ? "" : Number(data[key]);
        }
      });

      ws.addRow(data);

      this.columns.forEach((col: string, index: number) => {
        let cell = ws.getCell(`${col}${position + i}`);
        if (index >= 2) {
          if (Object.keys(this.formula).includes(col.toLowerCase())) {
            cell.value = { formula: `${this.formula[col.toLowerCase()].replaceAll('*', (position + i))}`, date1904: false };
          }
          cell.style = { numFmt: this.numberFormat };
        }
        cell.font = (data.aa_fnd_sysref_code == '') ? this.fontStyle.header : this.fontStyle.content;
        if (data.hasOwnProperty('acct_uacs_code') && data.acct_uacs_code != "" && !data.fnd_name.includes("SUB-TOTAL")) { // object of expenditure
          cell.font = this.fontStyle.content;
        }
        if (data.hasOwnProperty('acct_uacs_code') && data.acct_uacs_code == "" && this.allotmentClass.includes(data.fnd_name.replace("            ", ""))) { // allotment class 
          cell.font = this.fontStyle.content;
        }
        cell.border = this.borderStyle.full;
        cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (col == 'A') ? 'left' : 'right' };
      });
    });

  }

}
